import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import Tooltip from 'components/generic/Tooltip.component';
import useIsMobileViewport from 'hooks/useIsMobileViewport.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './Filter.module.scss';

export const Last18MonthsFilter = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const isMobileViewport = useIsMobileViewport();
  const tooltipSize = isMobileViewport ? 'md' : 'lg';

  return (
    <div
      data-bem="NextVisitFilter"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <Tooltip variant="top" width={tooltipSize} content={t('clientsEmailPage.lastVisit18MonthsTooltip')}>
        <div
          className={cn({
            [CN.filterButton]: true,
            [CN.isDisabled]: true,
          })}
        >
          <Icon variant="lockClose" width="sm" />
          {t('clientsEmailPage.lastVisit18Months')}
        </div>
      </Tooltip>
    </div>
  );
};
